/* eslint-env browser */
const requestWorker = new Worker('scripts/worker-request.js')

let pagesLimit = parseInt(document.querySelector('meta[name=limit]').getAttribute('content'), 10)
let content = document.querySelector('#main')
let loading = content ? content.querySelector('.loading') : null
let err = content ? content.querySelector('.err') : null

const updateRequest = () => {
  pagesLimit = parseInt(document.querySelector('meta[name=limit]').getAttribute('content'), 10)
  content = document.querySelector('#main')
  loading = content ? content.querySelector('.loading') : null
  err = content ? content.querySelector('.err') : null
}

let page = 1
let current = 0

const lazyRequest = () => {
  fastdom.measure(() => {
    if (page !== current && page <= pagesLimit) {
      const limit = document.documentElement.scrollTop + document.documentElement.clientHeight + 500
      const endPage = document.body.offsetHeight
      const isEndPage = endPage <= limit
      if (isEndPage) {
        current = page
        fastdom.mutate(() => {
          loading.classList.remove('--pause')
        })

        requestWorker.postMessage(page)
        requestWorker.onmessage = event => {
          const {
            success,
            code,
            response,
          } = event.data

          if (success) {
            page += 1
            const domResult = document.createRange().createContextualFragment(response)
            const all = Array.prototype.slice.call(domResult.querySelectorAll('.card-foto'))
            const fotos = Array.prototype.slice.call(domResult.querySelectorAll('img'))
            mosayc(all, fotos, true) // eslint-disable-line no-undef
          } else {
            console.error(code)
            fastdom.mutate(() => {
              loading.classList.add('--pause')
              err.classList.remove('--pause')
            })
          }
        }
      }
    }
  })
}
window.addEventListener('scroll', lazyRequest, false)
window.addEventListener('resize', updateRequest, false)
